import { AlpineComponent } from 'alpinejs';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

const GalleryComponent = (): AlpineComponent => ({

  positionNaviBtnBetweenSlides(swiper, SELECTOR_SWIPER) {
    swiper.on('resize', function() {
      const SELECTOR_SWIPER_BTN_NEXT = SELECTOR_SWIPER.querySelector('.swiper-button-next');
      const SELECTOR_SWIPER_BTN_PREV = SELECTOR_SWIPER.querySelector('.swiper-button-prev');
      const SELECTOR_SWIPER_SLIDE_ACTIVE = SELECTOR_SWIPER.querySelector('.swiper-slide-active');

      const WIDTH_SWIPER_SLIDE_ACTIVE = SELECTOR_SWIPER_SLIDE_ACTIVE.offsetWidth;
      const WIDTH_SWIPER = SELECTOR_SWIPER.offsetWidth;
      const DIFF_WIDTH_SWIPER = WIDTH_SWIPER - WIDTH_SWIPER_SLIDE_ACTIVE;

      //const BREAKPOINT_LARGE_VIEWPORT = 1440; //px
      const OFFSET_BTN_NEXT = 13;
      const OFFSET_BTN_PREV = 46;

      let offsetTabletViewport = 10;

      //if (window.innerWidth >= BREAKPOINT_LARGE_VIEWPORT) offsetTabletViewport = 10;

      SELECTOR_SWIPER_BTN_NEXT.style.cssText = `
        right: ${DIFF_WIDTH_SWIPER / 2 - OFFSET_BTN_NEXT - offsetTabletViewport}px;
      `;
      SELECTOR_SWIPER_BTN_PREV.style.cssText = `
        left: ${DIFF_WIDTH_SWIPER / 2 - OFFSET_BTN_PREV - offsetTabletViewport}px;
    `;
    });
  },

  init() {
    const SELECTOR_SWIPER_JS_INIT = this.$root;

    if (!SELECTOR_SWIPER_JS_INIT) return;

    const swiper = new Swiper(SELECTOR_SWIPER_JS_INIT, {
      modules: [Navigation],
      centeredSlides: true,
      slidesPerView: 1.2,
      spaceBetween: 20,
      lazyPreloadPrevNext: 0,
      simulateTouch: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      breakpoints: {
        768: {
          slidesPerView: 1.22,
          spaceBetween: 7,
        },
        1440: {
          slidesPerView: 1.22,
          spaceBetween: -38,
        },
      }
    });

    this.positionNaviBtnBetweenSlides(swiper, SELECTOR_SWIPER_JS_INIT)
  }
});

export default GalleryComponent;
